import { createRequest } from "../utils/utils";
import {STORAGE_KEY} from "../utils/define"
import $ from 'jquery'
import Vue from 'vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import { CHAT_MSG_TYPE } from "../S51WebGLSDK/define";
import { utils } from "../S51WebGLSDK/utils/utils";
Vue.use(ToastPlugin)
let vm = new Vue()

export function modelView(modelID) {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/webview/model_view",
{ image_id: modelID },
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}
export function companyCorpusList(modelID,page,num) {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/company/corpus/list",
{
company_id: modelID,
page: page,
num: num
},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}
export function cardView(modelID) {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/webview/card_view",
{
card_id: modelID
},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function imageList() {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/user/image/list",
{ page: 1, num: 20, status: 3 },
(res) => {
console.log("%c⧭", "color: #d90000", res.data);
if (res.code == 200) {
resolve(res)
} else {
console.error(res.msg);
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
}
);
})

}
export function getWalletStat() {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/wallet/stat",
{},
(res) => {
console.log("%c⧭", "color: #d90000", res.data);
if (res.code == 200) {
resolve(res)
} else {
console.error(res.msg);
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
}
);
})

}

export function config(version) {
return new Promise((resolve, reject) => {
createRequest("get", "applet/webview/config", { version: version },
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function qaList(modelViewId,type) {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/webview/qa/list",
{
image_id: type == '3d' ? modelViewId : '',
card_id: type == '2d' ? modelViewId : '',
page: 1,
num: 100
},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function headInfoSize(url) {
return new Promise((resolve, reject) => {
$.ajax({
type: 'HEAD',
url: url,
success: (res) => {

},
complete: (xhr, data) => {
resolve(xhr.getResponseHeader('Content-Length'))
},
error: function (errorMsg) {

console.log(errorMsg, '请求数据失败')

reject({
code: errorMsg.status,
msg: errorMsg.statusText
})
}
})
})

}

export function agedDialog(appId, word, voice) {
return new Promise((resolve, reject) => {
let body = {
app_id: appId,
}

if (voice) {
body['voice'] = voice
}
else {
body['word'] = `${word}`
}
console.log('请求聊天:',appId,word,voice)
createRequest("post", "applet/webview/dialog", body,
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
var [messageType,message] = utils.parseRobotMessage(res.data.resp)
res.data={
...res.data,
messageType,
message
}

resolve(res)
}
else {
reject(res.msg)
}
})

})

}

export function dialog(appId,word,voice,type,cardID) {
return new Promise((resolve, reject) => {
let body = {
app_id: appId,
type:type,
start_time:Number(localStorage.getItem(STORAGE_KEY.START_CHAT_TIME)),
card_id:cardID 
}

if (voice) {
body['voice'] = voice
}
else {
body['word'] = `${word}`
}
console.log('请求聊天:',appId,word,voice)
createRequest("post", "applet/chat/dialog", body,
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
var [messageType,message] = utils.parseRobotMessage(res.data.resp)
res.data={
...res.data,
messageType,
message
}

resolve(res)
}
else if(res.code ==60001 ){ //余额不足
resolve(res)
}
else {
reject(res.msg)
}
})

})

}

export function chatRecharge(starCoin) {
return new Promise((resolve, reject) => {
createRequest(
"post",
"applet/chat/recharge",
{ star_coin:starCoin},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function chatServiceStart(starCoin) {
return new Promise((resolve, reject) => {
createRequest(
"post",
"applet/chat/service/start",
{
app_id: starCoin
},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {

localStorage.setItem(STORAGE_KEY.START_CHAT_TIME,Math.floor(Date.now()/1000))
resolve(res)
}
else if (res.code == 500) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}
export function setCard(starCoin) {
return new Promise((resolve, reject) => {
createRequest(
"post",
"applet/webview/card/setting",
{
card_id: starCoin.card_id,
greet: starCoin.greet,
chat_audio_timbre: starCoin.chat_audio_timbre,
chat_type: starCoin.chat_type,
},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})
}
export function setImage(conf) {
return new Promise((resolve, reject) => {
createRequest(
"post",
"applet/webview/image/setting",
{
image_id: conf.image_id,
greet: conf.greet,
audio_timbre: conf.audio_timbre,
chat_type:conf.chat_type,
generate_cover:conf.generate_cover,
show_clothes_id: conf.show_clothes_id
},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})
}

export function getPublicsAudio(text, id) {
return new Promise((resolve, reject) => {
createRequest(
"post",
"applet/publics/text2audio",
{
audio_text: text,
audio_timbre: id,
},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}
export function chatWordToVoice(name,id) {
console.log('%c⧭', 'color: #00e600', name, id);
return new Promise((resolve, reject) => {
createRequest(
"post",
"applet/chat/word_to_voice",
{
app_id: id,
word: name,
},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function chatRechargeConfig() {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/chat/recharge/config",
{ },
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}
export function appletPublicsType() {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/publics/type",
{ },
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function getWalletRecharge(orderID) {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/wallet/recharge_info",
{ recharge_id:orderID},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function getChatStat() {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/chat/stat",
{},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}


export function getCharShareInfo(cardID) {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/share/card",
{card_id:cardID},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function getDefaultShareInfo() {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/share/default",
{},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}


export function getJSSDK(url) {
console.log('get jssdk',url)
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/webview/jssdk",
{url:url},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function shareHuman() {
return new Promise((resolve, reject) => {
createRequest(
"get",
"applet/share/virtual_human",
{},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function chatToken(param) {
return new Promise((resolve, reject) => {
createRequest(
"POST",
"applet/chat/token",
param,
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}
export function companyApply(param) {
return new Promise((resolve, reject) => {
createRequest(
"POST",
"applet/company/apply",
param,
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}
export function companyApplyInfo(param) {
return new Promise((resolve, reject) => {
createRequest(
"POST",
"applet/company/apply/info",
param,
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}

export function translateVoiceToText(param) {
return new Promise((resolve, reject) => {
createRequest(
"POST",
"applet/chat/voice_to_word",
param,
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
resolve(res)
}
else {
vm.$vux.toast.show({
type: "text",
text: res.msg,
});
reject(res.msg)
}
})
})

}


// WEBPACK FOOTER //
// ./src/api/api.js